import { render, staticRenderFns } from "./CardResult.vue?vue&type=template&id=8c8861ac"
import script from "./CardResult.vue?vue&type=script&lang=js"
export * from "./CardResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports